import { useContext } from 'react'
import { AppContext } from '../../../contextApi/ContextApi';

export default function ProfileOrderCardDetails({order, detailsFlag}) {
    const {primary_color, secondary_color, accent_color, currentUser} = useContext(AppContext);
    const deployOrderDetails=(order)=>{
        try{
            return order.map((_order, inx)=>{
                return <div key={`orderCard_${currentUser.name}_${inx}`} className='profile_orderCard_subDetails' dir='rtl' style={{backgroundColor:primary_color, color:secondary_color}}>
                <div className='profile_orderCard_subDetails_div' style={{border:`0.5px solid ${accent_color}`}}>
                    <p className='profile_orderCard_subDetails_header'>שם מוצר:</p>
                    <p className='profile_orderCard_subDetails_content'>{_order.name}</p>
                </div>
                <div className='profile_orderCard_subDetails_div' style={{border:`0.5px solid ${accent_color}`}}>
                    <p className='profile_orderCard_subDetails_header'>כמות:</p>
                    <p className='profile_orderCard_subDetails_content'>{_order.amount}</p>
                </div>
                <div className='profile_orderCard_subDetails_div' style={{border:`0.5px solid ${accent_color}`}}>
                    <p className='profile_orderCard_subDetails_header'>מחיר:</p>
                    <p className='profile_orderCard_subDetails_content'>{`${_order.price}₪ (${_order.price/_order.amount}₪ ליח')`}</p>
                </div>
                </div>
            })
        } catch(err){console.error("can't deploy orders",err)}
    }
    return (
      <div>
        {detailsFlag && <div className="profile_orderCard_subDetailsDiv" style={{backgroundColor:secondary_color, color:primary_color}}>
            {deployOrderDetails(order.order)}
            {order?.totalPrice && <div className='profile_orderCard_subDetails_total' style={{border:`0.5px solid ${accent_color}`, backgroundColor:primary_color, color:accent_color}}>
                <p>סכום סופי: {order?.totalPrice}₪</p>
            </div>}
        </div>}
      </div>
    )
}
